/* eslint-disable react/prop-types */
import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Constants from "../variables/Constants";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect, Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import Loader from "components/Loader";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import AddAlert from "@material-ui/icons/AddAlert";
let ProgressBar = props => {
  return (
    <div className="progress-bar">
      <Filler percentage={props.percentage} />
    </div>
  );
};
let Filler = props => {
  return (
    <div className="filler" style={{ width: `${props.percentage}%` }}></div>
  );
};
let fd = new FormData();
class UpdateDownloadMaster extends Component {
  state = {
    title: "",
    description: "",
    subject: "",
    faculty: "",
    file: "",
    redirect: false,
    notification: false,
    loading: false
  };
  componentDidMount() {
    let categoryData = this.props.location.state.categoryData;
    //console.log(categoryData);

    this.setState({
      title: categoryData.TITLE,
      description: categoryData.DESCRIPTION,
      file: categoryData.FILE_PATH,
      faculty: categoryData.FACULTY,
      subject: categoryData.SUBJECT
    });
  }
  handleFile = e => {
    this.setState({ [e.target.name]: e.target.files[0] }, () => {
      //console.log(this.state.file);
    });
  };
  handleSubmit = e => {
    this.setState({
      loading: true
    });
    e.preventDefault();
    fd.append("title", this.state.title);
    fd.append("description", this.state.description);
    fd.append("file_path", this.state.file);
    fd.append("subject", this.state.subject);
    fd.append("no_of_downloads", 786);
    fd.append("faculty", this.state.faculty);
    let categoryData = this.props.location.state.categoryData;
    let categoryId = categoryData.ID;
    axios
      .post(
        "https://admin.akclasses.in/api/download/update/" + categoryId,
        fd,
        {
          onUploadProgress: progressEvent => {
            this.setState({
              progress: Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              ),
              mediaProgress: true
            });
          }
        }
      )
      .then(() => {
        //console.log(resp);
        setTimeout(() => {
          this.setState({
            redirect: true
          });
        }, 1000);
        this.setState({
          notification: true,
          loading: false
        });
      });
  };
  handleInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/downloadsmaster"} />;
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.notification ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Download Updated!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Download Master</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Title"
                          id="float"
                          inputProps={{
                            value: this.state.title,
                            required: true,
                            onChange: e =>
                              this.setState({ title: e.target.value })
                          }}
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Faculty"
                          id="float"
                          inputProps={{
                            value: this.state.faculty,
                            required: true,
                            onChange: e =>
                              this.setState({ faculty: e.target.value })
                          }}
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Subject"
                          id="float"
                          inputProps={{
                            required: true,
                            value: this.state.subject,
                            onChange: e =>
                              this.setState({ subject: e.target.value })
                          }}
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <label>Upload File</label>
                        <br />
                        <input
                          name="file"
                          onChange={this.handleFile}
                          // accept="image/*"
                          type="file"
                        />
                        <img
                          width="200px"
                          src={Constants.imgUrl + this.state.file}
                          alt=""
                        />
                      </GridItem>
                      <br />
                      <GridItem xs={12} sm={12} md={12}>
                        <label htmlFor="">Short Description</label>
                        <br />
                        <textarea
                          name="description"
                          onChange={this.handleInput}
                          className="form-control"
                          cols="119"
                          rows="6"
                          value={this.state.description}
                        ></textarea>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <br />
                        {this.state.mediaProgress ? (
                          <ProgressBar percentage={this.state.progress} />
                        ) : null}
                      </GridItem>
                      <br />
                      <GridItem xs={12} sm={12} md={4}>
                        <Button className="" color="warning" type="submit">
                          {this.state.loading ? (
                            <Loader />
                          ) : (
                            "Update Download Master"
                          )}
                        </Button>
                        <Link
                          to={{
                            pathname: "/admin/downloadsmaster"
                          }}
                        >
                          <Button className="btn-round" color="danger">
                            Cancel
                          </Button>
                        </Link>
                      </GridItem>
                    </GridContainer>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default UpdateDownloadMaster;
